import { library } from '@fortawesome/fontawesome-svg-core';
import { faHeart } from '@fortawesome/pro-light-svg-icons';
import {
  IconName,
  faHeart as faHeartSolid,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { COLORS } from '../../styles/colors';

export interface WxButtonIconProps {
  icon: IconName;
  active?: boolean;
  onClick: () => void;
}

library.add(faHeart, faHeartSolid);

const WxButtonIcon = ({ icon, onClick, active = false }: WxButtonIconProps) => {
  return (
    <Container onClick={onClick}>
      <FontAwesomeIcon icon={[active ? 'fas' : 'fal', icon]} />
    </Container>
  );
};

const Container = styled.div`
  min-width: 34px;
  min-height: 34px;
  color: colors.$red;
  background-color: ${COLORS.transparent};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0.75rem;
`;

export default WxButtonIcon;
